import { WidgetConfig, WidgetId, WidgetSections, Widgets } from './types'

const BaseConfig = {
  [WidgetSections.summary]: {
    [WidgetId.summary_conversion_rate]: {
      id: WidgetId.summary_conversion_rate,
      title: 'Conversion Rate'
    },
    [WidgetId.summary_net_sales]: {
      id: WidgetId.summary_net_sales,
      title: 'Net Sales'
    },
    [WidgetId.summary_aov]: {
      id: WidgetId.summary_aov,
      title: 'AOV'
    },
    [WidgetId.summary_orders]: {
      id: WidgetId.summary_orders,
      title: 'Total Orders'
    },
    [WidgetId.summary_prepaid_share]: {
      id: WidgetId.summary_prepaid_share,
      title: 'Prepaid Share'
    }
  },
  [WidgetSections.conversion]: {
    [WidgetId.conversion_rate]: {
      id: WidgetId.conversion_rate,
      title: 'Conversion Rate'
    },
    [WidgetId.conversion_funnel]: {
      id: WidgetId.conversion_funnel,
      title: 'Conversion Funnel'
    },
    [WidgetId.conversion_address_prefilled_rate]: {
      id: WidgetId.conversion_address_prefilled_rate,
      title: 'Address Prefilled Rate'
    },
    [WidgetId.conversion_rate_comparison]: {
      id: WidgetId.conversion_rate_comparison,
      title: 'Conversion Rate Comparison'
    },
    [WidgetId.conversion_rate_timescale]: {
      id: WidgetId.conversion_rate_timescale,
      title: 'Conversion Rate'
    },
    [WidgetId.conversion_auto_logged_in_sessions]: {
      id: WidgetId.conversion_auto_logged_in_sessions,
      title: 'Auto Logged-in Sessions'
    },
    [WidgetId.exit_checkout_survey]: {
      id: WidgetId.exit_checkout_survey,
      title: 'Exit Checkout Survey'
    }
  },
  [WidgetSections.payments]: {
    [WidgetId.payment_split]: {
      id: WidgetId.payment_split,
      title: 'Payment Split'
    },
    [WidgetId.payment_prepaid_share]: {
      id: WidgetId.payment_prepaid_share,
      title: 'Prepaid Share'
    },
    [WidgetId.payment_methods_conversion_rates]: {
      id: WidgetId.payment_methods_conversion_rates,
      title: 'Payment Methods Conversion Rates'
    },
    [WidgetId.payment_gateways_success_rate]: {
      id: WidgetId.payment_gateways_success_rate,
      title: 'Payment Gateways Success Rate'
    }
  },
  [WidgetSections.orders]: {
    [WidgetId.orders]: {
      id: WidgetId.orders,
      title: 'Orders'
    },
    [WidgetId.orders_breakdown]: {
      id: WidgetId.orders_breakdown,
      title: 'Orders Breakdown'
    },
    [WidgetId.orders_sales]: {
      id: WidgetId.orders_sales,
      title: 'Orders Sales'
    },
    [WidgetId.orders_average_order_value]: {
      id: WidgetId.orders_average_order_value,
      title: 'Orders Average Order Value'
    },
    [WidgetId.orders_sales_breakdown]: {
      id: WidgetId.orders_sales_breakdown,
      title: 'Orders Sales Breakdown'
    },
    [WidgetId.orders_abandoned_checkout_recovery]: {
      id: WidgetId.orders_abandoned_checkout_recovery,
      title: 'Orders Abandoned Checkout Recovery'
    },
    [WidgetId.orders_sales_breakdown_by_utm]: {
      id: WidgetId.orders_sales_breakdown_by_utm,
      title: 'Orders Sales Breakdown by UTM'
    }
  },
  [WidgetSections.discounts]: {
    [WidgetId.discounts_conversion_rate]: {
      id: WidgetId.discounts_conversion_rate,
      title: 'Discounts Conversion Rate'
    },
    [WidgetId.discounts_average_order_value]: {
      id: WidgetId.discounts_average_order_value,
      title: 'Discounts Average Order Value'
    },
    [WidgetId.discounts_order_placed_comparison]: {
      id: WidgetId.discounts_order_placed_comparison,
      title: 'Discounts Order Placed Comparison'
    },
    [WidgetId.discounts_your_discounts]: {
      id: WidgetId.discounts_your_discounts,
      title: 'Your Discounts'
    },
    [WidgetId.cod_orders_converted_to_prepaid]: {
      id: WidgetId.cod_orders_converted_to_prepaid,
      title: 'COD Orders Converted to Prepaid'
    }
  },
  [WidgetSections.rto]: {
    [WidgetId.rto_orders_converted_to_prepaid]: {
      id: WidgetId.rto_orders_converted_to_prepaid,
      title: 'RTO Orders Converted to Prepaid'
    }
  },
  [WidgetSections.upsells]: {
    [WidgetId.upsells_orders_converted_to_prepaid]: {
      id: WidgetId.upsells_orders_converted_to_prepaid,
      title: 'Upsells Orders Converted to Prepaid'
    }
  },
  [WidgetSections.rewards]: {
    [WidgetId.rewards_orders_converted_to_prepaid]: {
      id: WidgetId.rewards_orders_converted_to_prepaid,
      title: 'Rewards Orders Converted to Prepaid'
    }
  }

  // TODO(shradhan): add cod section discuss if this has to be added
  // [WidgetSections.cod]: {
  //   [WidgetId.cod_orders_converted_to_prepaid]: {
  //     id: WidgetId.cod_orders_converted_to_prepaid,
  //     title: 'COD Orders Converted to Prepaid'
  //   }
  // }
}

export const getAnalyticsConfig = (
  widgets: Widgets['widgetConfig']
): {
  [key in WidgetSections]: {
    [key in WidgetId]: WidgetConfig
  }
} => {
  const widgetsToRender = Object.entries(widgets).map(([section, graphs]) => {
    if (BaseConfig[section as WidgetSections]) {
      const baseSection = BaseConfig[section as WidgetSections]
      const filteredGraphs = graphs.filter(graph => {
        return baseSection.hasOwnProperty(graph.widget_id)
      })
      const graphEntries = filteredGraphs.map(graph => {
        const baseWidget = baseSection[graph.widget_id as keyof typeof baseSection] as { id: string; title: string }
        return [
          graph.widget_id,
          {
            ...baseWidget,
            ...graph,
            // Keep canonical UI titles from frontend config for consistency.
            widget_title: baseWidget.title
          }
        ]
      })

      const graphObject = Object.fromEntries(graphEntries)
      return [section, graphObject]
    }

    return [section, {}]
  })

  const widgetsToRenderEntries = Object.fromEntries(
    widgetsToRender.filter(widget => {
      const widgetKeys = Object.keys(widget[1])
      const enabledWidgets = widgetKeys.filter(key => widget[1]?.[key]?.enabled)
      return enabledWidgets?.length > 0
    })
  )
  return widgetsToRenderEntries
}
